import urlRegex from 'url-regex';
var validUrl = function validUrl(string) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return urlRegex(options).test(string);
};
export default validUrl;